/**
 * Cart drawer empty-state recommendations slider.
 * Loaded from cart-drawer.liquid so it always runs: inline scripts inside
 * cart-drawer-recommendations.liquid are not executed when that markup is
 * injected via section morph (e.g. after removing the last line item).
 */
(function () {
  if (!window.cartDrawerRecommendations) {
    window.cartDrawerRecommendations = {};
  }

  const sliderId = 'cart-drawer-recommendations-slider';
  const containerId = 'cart-drawer-recommendations-slider-container';

  if (!window.cartDrawerRecommendations.state) {
    window.cartDrawerRecommendations.state = {
      currentIndex: 0,
      itemsPerView: 1.2,
      sliderInstance: null,
    };
  }

  const state = window.cartDrawerRecommendations.state;

  function initSlider() {
    const slider = document.getElementById(sliderId);
    const container = document.getElementById(containerId);
    const prevButton = document.getElementById('cart-drawer-recommendations-prev');
    const nextButton = document.getElementById('cart-drawer-recommendations-next');

    if (!slider || !container) return;

    const items = container.querySelectorAll('.cart-drawer-recommendations-slider__item');
    if (items.length === 0) return;

    function updateItemsPerView() {
      const width = window.innerWidth;
      if (width >= 990) {
        state.itemsPerView = 1.2;
      } else if (width >= 750) {
        state.itemsPerView = 1.2;
      } else {
        state.itemsPerView = 1.2;
      }
    }

    function updateSlider() {
      updateItemsPerView();
      const maxIndex = Math.max(0, items.length - state.itemsPerView);
      const translateX = -(state.currentIndex * (100 / state.itemsPerView));
      container.style.transform = `translateX(${translateX}%)`;
      container.style.transition = 'transform 0.3s ease';

      if (prevButton) {
        prevButton.disabled = state.currentIndex === 0;
        prevButton.style.opacity = state.currentIndex === 0 ? '0.3' : '1';
        prevButton.style.pointerEvents = state.currentIndex === 0 ? 'none' : 'auto';
      }
      if (nextButton) {
        nextButton.disabled = state.currentIndex >= maxIndex;
        nextButton.style.opacity = state.currentIndex >= maxIndex ? '0.3' : '1';
        nextButton.style.pointerEvents = state.currentIndex >= maxIndex ? 'none' : 'auto';
      }
    }

    function slideNext() {
      const maxIndex = Math.max(0, items.length - state.itemsPerView);
      if (state.currentIndex < maxIndex) {
        state.currentIndex++;
        updateSlider();
      }
    }

    function slidePrev() {
      if (state.currentIndex > 0) {
        state.currentIndex--;
        updateSlider();
      }
    }

    if (state.sliderInstance) {
      state.sliderInstance.destroy();
      state.sliderInstance = null;
    }

    if (nextButton) {
      nextButton.addEventListener('click', slideNext);
    }
    if (prevButton) {
      prevButton.addEventListener('click', slidePrev);
    }

    updateSlider();
    window.addEventListener('resize', updateSlider);

    state.sliderInstance = {
      next: slideNext,
      prev: slidePrev,
      update: updateSlider,
      destroy: function () {
        if (nextButton) nextButton.removeEventListener('click', slideNext);
        if (prevButton) prevButton.removeEventListener('click', slidePrev);
        window.removeEventListener('resize', updateSlider);
      },
    };
  }

  function tryInitSlider() {
    const slider = document.getElementById(sliderId);
    const container = document.getElementById(containerId);
    if (!slider || !container) return false;
    const items = container.querySelectorAll('.cart-drawer-recommendations-slider__item');
    if (!items || items.length === 0) return false;
    state.currentIndex = 0;
    initSlider();
    return true;
  }

  function tryInitSliderWithRetries(retryDelays) {
    retryDelays = retryDelays || [0, 50, 150, 350, 600];
    const timeouts = [];
    for (let i = 0; i < retryDelays.length; i++) {
      (function (delay) {
        const id = setTimeout(function () {
          if (tryInitSlider()) {
            timeouts.forEach(clearTimeout);
          }
        }, delay);
        timeouts.push(id);
      })(retryDelays[i]);
    }
  }

  window.cartDrawerRecommendations.tryInitSlider = tryInitSlider;
  window.cartDrawerRecommendations.tryInitSliderWithRetries = tryInitSliderWithRetries;

  function setup() {
    if (window.cartDrawerRecommendations.setupComplete) {
      tryInitSliderWithRetries();
      return;
    }

    const cartDrawer = document.querySelector('cart-drawer-component');
    if (!cartDrawer) {
      setTimeout(setup, 100);
      return;
    }

    const dialog = cartDrawer.querySelector('.cart-drawer__dialog');
    if (!dialog) {
      setTimeout(setup, 100);
      return;
    }

    const observer = new MutationObserver((mutations) => {
      const dialogOpened = mutations.some(
        (m) => m.type === 'attributes' && m.attributeName === 'open' && dialog.open
      );

      const contentChanged = mutations.some(
        (m) => m.type === 'childList' && (m.addedNodes.length > 0 || m.removedNodes.length > 0)
      );

      if (dialogOpened || contentChanged) {
        if (contentChanged) {
          if (state.sliderInstance) {
            state.sliderInstance.destroy();
            state.sliderInstance = null;
          }
          state.currentIndex = 0;
        }
        requestAnimationFrame(() => {
          tryInitSliderWithRetries();
        });
      }
    });

    observer.observe(dialog, {
      attributes: true,
      attributeFilter: ['open'],
      childList: true,
      subtree: true,
    });

    tryInitSliderWithRetries([0, 100, 300]);

    if (dialog.open) {
      tryInitSliderWithRetries();
    }

    function handleCartUpdate() {
      if (state.sliderInstance) {
        state.sliderInstance.destroy();
        state.sliderInstance = null;
      }
      state.currentIndex = 0;
      requestAnimationFrame(() => {
        tryInitSliderWithRetries([0, 100, 300, 500, 800]);
      });
    }

    if (typeof ThemeEvents !== 'undefined' && ThemeEvents.cartUpdate) {
      document.addEventListener(ThemeEvents.cartUpdate, handleCartUpdate);
    }
    document.addEventListener('cart:update', handleCartUpdate);
    document.addEventListener('cartUpdate', handleCartUpdate);

    window.cartDrawerRecommendations.setupComplete = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
